<template>
  <div class="mine-container light-bg" ref="mineContain">
    <!--用户信息-->
    <div class="user-info-content">
      <div class="user-info-box">
        <div class="left-content" @click="gotoSetInfo">
          <div class="user-img">
            <img v-bind:src="userInfo.headimgurl" alt="" />
          </div>
          <div class="user-name">{{ userInfo.nickname }}</div>
        </div>
        <van-icon name="arrow" size="20"  @click="gotoSetInfo"/>
      </div>
      <i class="iconfont icon-tuichu1 log-out-icon" @click="openSignOut"></i>
    </div>
    <!-- 钱包 -->
    <div class='wallet-box' @click="gotoWallet">
      <div>
        <span>我的钱包 </span>
        <!-- 是供应商 -->
        <span v-if='isDistributor'>
          <span> <b>{{totalBean}}</b>金豆</span>
        </span>
        <!-- 不是供应商 -->
        <span style="vertical-align: sub;" v-else>****</span>
      </div>
      <van-icon name="arrow" size="20" />
    </div>
    <!--订单-->
    <div class="order-nav">
      <div class="nav-header" @click="gotoAllOrder(0)">
        <span class="my-order">我的订单</span>
        <span class="goto-all-order">查看全部订单<van-icon name="arrow" size="14"/></span>
      </div>
      <van-tabbar :fixed="false" :value="-1" class="nav-container">
        <van-tabbar-item @click="gotoAllOrder(1)">
          <span>待付款</span>
          <van-icon class="tab-color" name="card" slot-scope="props" slot="icon" />
        </van-tabbar-item>
        <van-tabbar-item @click="gotoAllOrder(4)">
          <span>待收货</span>
          <van-icon class="tab-color" name="send-gift" slot="icon" />
        </van-tabbar-item>
        <van-tabbar-item @click="gotoAllOrder(7)">
          <span>已完成</span>
          <van-icon class="tab-color" name="bag" slot="icon" />
        </van-tabbar-item>
        <van-tabbar-item @click="gotoAllOrder(5)">
          <span>评价</span>
          <van-icon class="tab-color" name="chat" slot="icon"></van-icon>
        </van-tabbar-item>
        <van-tabbar-item>
          <span>售后</span>
          <van-icon class="tab-color nodev-color" name="phone-circle" slot="icon"></van-icon>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div class="gotoset-address" @click="gotoSetAddress">
      <span>收货地址</span>
      <van-icon name="arrow" size="24" />
    </div>
    <div class="gotoset-address" @click="gotoAccountSecurity">
      <span>账号安全</span>
      <van-icon name="arrow" size="24" />
    </div>
    <div class="gotoset-address" @click="gotoSettlein">
      <span>我要入驻</span>
      <van-icon name="arrow" size="24" />
    </div>
    <van-action-sheet v-model="display.signOut" cancel-text="取消" :actions="actions" @select="onSelect" />
    <div @click='openCode'>开发者调试</div>
    <div @click='openCode2'>支付调试</div>
  </div>
</template>

<script>
import api from 'api/user';
import api2 from 'api/wallet';
import { mapState, mapMutations } from 'vuex';
import { getToken, gotoOAuth } from 'common/js/ovoSystem';
import { Dialog } from 'vant';
export default {
  data() {
    return {
      value:1,
      display:{
        signOut: false
      },
      actions: [{name: '退出', color: 'red'}],
      totalBean: 0
    };
  },
  computed: {
    isDistributor() { //1 :是供应商
      return this.userInfo.isDistributor == 1;
    },
    ...mapState(['userInfo'])
  },
  created() {
    this.getTotalBean()
    //this.getUserInfo();
  },
  mounted(){
    this.$refs['mineContain'].style.height = window.innerHeight + 'px';
  },
  methods: {
    async getUserInfo() {
      const data = await api.getUserInfo();
      this.userInfo = data;
      localStorage.setItem('userId_wdsx', data.userId);
      console.log(data);
    },
    //获取金豆数量
    getTotalBean() {
      api2.getCommission()
        .then(res => {
          this.totalBean = res.actualCommission;
          console.log(res)
        })
    },
    //前往所有订单
    gotoAllOrder(type) {
      this.$router.push({
        path: '/order',
        query:{
          type: type
        }
      });
    },
    gotoSetAddress(){
      //设置是从个人中心页进入收货地址
      this.setAddressFrom('mine');
      this.$router.push({
        path: '/address'
      })
    },
    //前往个人资料修改
    gotoSetInfo() {
      this.$router.push({
        name: 'personalInfo'
      })
    },
    //前往安全中心
    gotoAccountSecurity() {
      this.$router.push({
        name: 'securityCenter'
      })
    },
    //前往入驻
    gotoSettlein() {
      // TODO: //userType   1 是平台  2 是供应商
      this.$router.push({
        name: 'settleInList'
      })
    },
    //前往钱包
    gotoWallet() {
      if(this.$s) {

      }else{

      }
      this.$router.push({
        name: 'wallet'
      })
    },
    //退出登录
    openSignOut() {
      this.display.signOut = true;
    },
    //选择退出
    onSelect() {
      localStorage.removeItem('userId_wdsx')
      localStorage.removeItem('ticket_wdsx')
      this.$router.push({
        name:'home'
      })
    },
    openCode() {
      gotoOAuth()
    },
    openCode2() {
      //window.location.href = `http://wdsxapi.ovopark.com/settle?type=2&orderId=182&token=305C11DC2D10C0FE40773FD9D3B1354E`
      window.location.href = `http://wdsxapi.ovopark.com/settle?type=2&orderId=184&token=305C11DC2D10C0FE40773FD9D3B1354E`
    },
    ...mapMutations(['setAddressFrom'])
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.user-info-content{
  position: relative;
}
.user-info-box {
  position: relative;
  display: flex;
  height: 18vh;
  padding: 0 20px;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  .left-content {
    display: flex;
    align-items: center;
    .user-img {
      width: 60px;
      height: 60px;
      border-radius: 100%;
      overflow: hidden;
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .user-name {
      margin-left: 10px;
      font-size: 14px;
    }
  }
}
.log-out-icon{
  position: absolute;
  right: 10px;
  top: 0px;
  color: $red-color;
  font-size: 23px;
  font-weight: bold;
}
.wallet-box{
  display: flex;
  justify-content: space-between;
  height: 50px;
  align-items: center;
  padding: 0 10px;
  background: #fff;
  line-height: 50px;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}
.order-nav {
  margin: 15px 0;
  background: #fff;
  .nav-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 10px;
    font-size: 14px;
    color: $weight-word-color;
    border: 1px solid $light-line-color;
    .my-order {
      font-weight: bold;
      font-size: 15px;
      vertical-align: middle;
    }
    .goto-all-order {
      float: right;
      color: $light-color;
      font-size: 13px;
      vertical-align: middle;
    }
  }
  .nav-container {
    padding: 7px 0;
  }
  .tab-color {
    color: $theme-color;
    font-size: 25px;
  }
  .nodev-color{
    color: #ddd;
  }
}
.gotoset-address{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 10px;
  font-size: 15px;
  background: #fff;
  border-bottom: 1px solid $light-line-color;
}
</style>
